import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/precisionpart-frontend/precisionpart-frontend/src/components/blocks/AboutServiceSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/precisionpart-frontend/precisionpart-frontend/src/components/blocks/ParallaxHero.tsx");
